import { FC } from 'react';

const Reloading: FC = () => {
  return <div>Reloading</div>;
};

export default Reloading;
